var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17610_28252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6277 0 24 5.37234 24 12C24 18.6277 18.6277 24 12 24C5.37234 24 0 18.6277 0 12C0 5.37234 5.37234 0 12 0Z",
    fill: "url(#paint0_linear_17610_28252)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47488 7.4707C10.9761 7.4707 13.0039 9.49852 13.0039 11.9998C13.0039 14.501 10.9761 16.5288 8.47488 16.5288C5.9741 16.5288 3.94629 14.501 3.94629 11.9998C3.94629 9.49852 5.9741 7.4707 8.47488 7.4707ZM19.2552 8.18602C19.6963 8.18602 20.0535 9.89367 20.0535 11.9998C20.0535 14.1059 19.6963 15.8135 19.2552 15.8135C18.8146 15.8135 18.4569 14.1059 18.4569 11.9998C18.4569 9.89367 18.8146 8.18602 19.2552 8.18602ZM15.7218 7.82836C16.9874 7.82836 18.013 9.69586 18.013 11.9998C18.013 14.3037 16.9874 16.1712 15.7218 16.1712C14.4561 16.1712 13.43 14.3037 13.43 11.9998C13.43 9.69586 14.4561 7.82836 15.7218 7.82836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17610_28252",
    x1: 3.17953,
    y1: 3.86344,
    x2: 22.2277,
    y2: 18.2803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17610_28252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRounded);
export default __webpack_public_path__ + "static/media/medium-rounded.5f20ffac5ee91bbdc661f30205052aa5.svg";
export { ForwardRef as ReactComponent };